import { PortfolioLoadingSkeleton } from '@/components/portfolio/portfolio-loading-skeleton';

/**
 * Route fallback + `<OwnPortfolio>` auth/public-user gate — mirrors
 * `<PortfolioLoadingSkeleton>` so CLS stays aligned with `{@link PortfolioBody}`.
 */
export default function PortfolioLoading(): React.ReactNode {
  return <PortfolioLoadingSkeleton pnlViewerMode="own" />;
}
